export enum SessionStorageKey {
  patientIntake = "patientIntake",
  patientResponsibilityEstimateUsd = "patientResponsibilityEstimateUsd",
  appointmentClinicianIds = "appointmentClinicianIds",
  appointmentStart = "appointmentStart",
  isNewPatient = "isNewPatient",
  isTelehealthPlan = "isTelehealthPlan",
  isTelehealthBuyflow = "isTelehealthBuyflow",
}
